import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    charCount: {
        textAlign: "right"
    },
    textArea: {
        height: 100,
        marginBottom: 50,
        width: "100%"
    }
}));

export default useStyles;